/**
 * ProblemStatement component is used to display the Activity title and the problem statement of a programming
 * activity within a course.
 */

import React, { useState, useRef, useEffect } from "react";
import { Accordion, Card } from "react-bootstrap";
import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";
import styles from "./ProblemStatement.module.css";
import { useDispatch } from "react-redux";
import { setChatbotExternalData } from "../../../../../../../Store/Chatbot/Action.js";
import { useSelector } from "react-redux";

export default function ProblemStatement({ activity_title, activity_description, additionalDocument }) {
  //State to manage the accordion open and close
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const [menu, setMenu] = useState(null);
  const bodhibotEnabled = useSelector(
    (state) => state.chatbot.bodhibotStatusObj?.BodhiBotStatus
  );

   useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handleContextMenu = (e) => {
      const selected = window.getSelection().toString().trim();
      if (!selected || !bodhibotEnabled) return; // only show if something is selected
      e.preventDefault(); // prevent default browser menu
      setMenu({ x: e.clientX, y: e.clientY, text: selected });
    };

    const handleClick = () => setMenu(null);

    el.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("click", handleClick);
    return () => {
      el.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("click", handleClick);
    };
  }, [bodhibotEnabled]);

  const handleAskBodhibot = () => {
    if (!menu?.text || !bodhibotEnabled) return;
    dispatch(
      setChatbotExternalData({
        type: "problemStatement",
        content: menu.text,
        source: "problemStatement",
      })
    );
    setMenu(null);
  };

  const renderDocumentAlert = () => {
    if (!additionalDocument) {
      return null;
    }
    //Rendering an alert to inform the student about the additional files provided by the instructor
    return (
      <>
        <h5 style={{ marginBottom: "10px" }}>
          Helper Document:{"  "}
          <a
            href={URL.createObjectURL(additionalDocument)}
            download={additionalDocument.name}
            style={{ marginRight: "8px" }}
          >
            <u>{additionalDocument.name}</u>
            {""}
          </a>
        </h5>
      </>
    );
  };

  return (
    <div>
      {/* Activity title */}
      <div style={{ marginLeft: "10px", marginBottom: "25px" }}>
        <h2>{activity_title}</h2>
      </div>
      {/* Accordion to display the problem statement */}
      <Accordion defaultActiveKey="0">
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Problem Statement</div>
              <div>
                {isAccordionOpen ? (
                  <RiArrowDropDownLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                ) : (
                  <RiArrowDropRightLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                )}
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse in={isAccordionOpen}>
            <Card.Body>
              <>
                  {renderDocumentAlert()}
                <div
                  ref={containerRef}
                  style={{
                    overflowX: "hidden",
                    wordWrap: "break-word",
                  }}
                  className={styles.card_body}
                  // Display the problem statement using dangerouslySetInnerHTML to render the HTML content
                  dangerouslySetInnerHTML={{ __html: activity_description }}
                />
                {menu && (
                  <div
                    onClick={handleAskBodhibot}
                    style={{
                      position: "fixed",
                      top: menu.y,
                      left: menu.x,
                      background: "white",
                      border: "1px solid #ccc",
                      padding: "5px 10px",
                      borderRadius: 4,
                      cursor: "pointer",
                      zIndex: 9999,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    }}
                  >
                    Ask Bodhibot
                  </div>
                )}
              </>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}
